import React from 'react';

interface CardSectionProps {
  title?: string;
  children: React.ReactNode;
}

export default function CardSection({ title, children }: CardSectionProps) {
  return (
    <div className="card bg-white p-6 rounded-md border border-gray-200 mb-6 shadow-sm">
      {title && <h3 className="text-2xl mt-0 mb-3">{title}</h3>}
      {children}
    </div>
  );
} 